import React from 'react';

// DEPENDENCIES
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';

// FUNCTIONS
import { checkRole } from 'functions.js';

// HOOKS
import { useSalesStatus } from '../hooks/useSalesStatus';

// LOCAL COMPONENTS
import BackoutSidebar from './BackoutSidebar';
import CarryoverSidebar from './CarryoverSidebar';
//import CarryoverButton from './CarryoverButton';
import EpostSidebar from './EpostSidebar';
//import EpostButton from './EpostButton';
import PrintButton from '../../../tools/PrintSelectButton';

// STYLE
import styles from './salesButtons.module.scss';

// MAIN COMPONENT
const SalesButtons = () => {

  // REACT ROUTER
  const { recordID } = useParams();

  // FORMIK
  const { values } = useFormikContext() || {};
  const {
    stock_num,
    customer_first_name,
    customer_last_name,
    daily_sales_inventory_id
  } = values || {};

  // HOOKS
  const { isBackout } = useSalesStatus();

  // RENDER
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <PrintButton
          dailySalesInventoryId={daily_sales_inventory_id}
          salesId={recordID}
          customerName={`${customer_first_name} ${customer_last_name}`}
          stockNum={stock_num}
          isBackout={isBackout}
        />
        {checkRole(['dslAdmin', 'salesManager']) && <>
          <BackoutSidebar.Button
            outline
            fullWidth={false}
            size="sm"
          />
          <CarryoverSidebar.Button
            outline
            fullWidth={false}
            size="sm"
          />
        </>}
        <EpostSidebar.Button
          outline
          fullWidth={false}
          size="sm"
        />
      </div>
    </div>
  );
};

// EXPORT
export default SalesButtons;
